import http from '@/plugins/axios_plugin';

class ServiceFaturamento {
    listarPedidos () {
        return http.get('/api/pedidos/listar/faturamento')
    }
    
    abrir (pedido) {
        return http.get('/api/pedidos/' + pedido + '/abrir')
    }
        
    salvarPromissorias (pedido_id, promissorias) {
        return http.post('/api/pedidos/' + pedido_id + '/promissorias/salvar', promissorias)
    }
}

export default new ServiceFaturamento();